export const FETCH_PROFESSION_FAQ_REQUEST = "FETCH_PROFESSION_FAQ_REQUEST";
export const ADD_PROFESSION_FAQ_REQUEST = "ADD_PROFESSION_FAQ_REQUEST";
export const EDIT_PROFESSION_FAQ_REQUEST = "EDIT_PROFESSION_FAQ_REQUEST";
export const DELETE_PROFESSION_FAQ_REQUEST = "DELETE_PROFESSION_FAQ_REQUEST";
